import React from "react";
import { useDispatch } from "react-redux";
import Icon from "../../../../../icon";
import { Changer, ChangerPopup } from "../../../EditorBar";
import { Range } from "../../../../Form";
import { IProps } from "./interfaces";
import getScale from "../getScale";
import { FormattedMessage } from "react-intl";
import { editTask } from "../../../../../store/plan/actions";
import { post } from "../../../../../actions/general";
import { TScoreData } from "../../../../../../common/types";
import messages from "./messages";

const ChangeScale = ({ openChanger, handleChangeOpen, plan, taskIndex, setPopupRef, max = 1.8, min = 0.8, changeCallback }: IProps) => {
    const task = plan.tasks[taskIndex];
    const dispatch = useDispatch();
    const handleChangeScale = (val: number) => {
        dispatch(editTask({ taskIndex, changingProp: "scale", val }));
        if (changeCallback) changeCallback();
    };
    
    const handleChangeScaleStop = () => {
        const { scale } = task.data as TScoreData;
        dispatch(post("task-scale", {
            planId: plan._id,
            index: taskIndex,
            scale,
        }));
        if (changeCallback) changeCallback();
    };
    return (
        <Changer active={openChanger === "scale"}>
            <div
                onClick={e => {
                    e.stopPropagation();
                    handleChangeOpen("scale");
                }}
            >
                <Icon i="scale" />
            </div>
            {openChanger === "scale" && (
                <ChangerPopup setRef={setPopupRef}>
                    <Range
                        scale={1}
                        value={getScale(plan, task)}
                        onChange={handleChangeScale}
                        onStop={handleChangeScaleStop}
                        min={min}
                        max={max}
                        step={0.01}
                        label={<FormattedMessage {...messages.scaling} />}
                    />
                </ChangerPopup>
            )}
        </Changer>
    );
};

export default ChangeScale;
